// extracted by mini-css-extract-plugin
export default {"posts":"home_posts__Red5s","postimg":"home_postimg__I4NVR","postvid":"home_postvid__K3Z14","pfp":"home_pfp__G6pNU"};